'use strict';

import GoogleMap from './../common/GoogleMap';

export default function comparisonMap () {
    let $objects = $('.js-comparison-object');

    if (!$objects.length) {
        return;
    }

    let makeIcon = () => ({
        path: 'M25,0C14.65,0,6.25,8.4,6.25,18.75 C6.25,29.1,25,50,25,50s18.75-20.9,18.75-31.25C43.75,8.4,35.35,0,25,0z',
        //fillColor: options.fillColor,
        fillOpacity: 1,
        //strokeColor: options.fillColor,
        strokeWeight: 0,
        scale: 0.575,
        size: new google.maps.Size(38, 50),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(19, 50),
        labelOrigin: new google.maps.Point(24, 20)
    });

    let comparisonMap = new GoogleMap({
        mapSelector: '.js-comparison-map',
        callback () {
            $objects.each((idx, el) => {
                let $el = $(el);
                let icon = makeIcon();
                if ($el.attr('data-marker-color')) {
                    icon.fillColor = $el.attr('data-marker-color');
                    icon.strokeColor = $el.attr('data-marker-color');
                }
                comparisonMap.setMarker({
                    rmbID: $el.attr('data-id'),
                    lat: $el.attr('data-lat'),
                    lng: $el.attr('data-lng'),
                    label: {
                        color: '#fff',
                        text: `${idx + 1}`
                    },
                    marker: {
                        icon: icon,
                    },
                    infoWindow: {
                        content: $el.find('.google-maps-window').html()
                    },
                    draggable:true
                });

                comparisonMap.$gMap.setCenter(new google.maps.LatLng(
                    $objects.getPropAvg('data-lat'),
                    $objects.getPropAvg('data-lng')
                ));
            });
        }
    });

    $(window).on('gMap:centerMap', () => {
        comparisonMap.$gMap.setCenter(new google.maps.LatLng(
            $objects.getPropAvg('data-lat'),
            $objects.getPropAvg('data-lng')
        ));
    });
}
